import { c as _c } from "react/compiler-runtime";
interface GeneralSurgeryIconProps {
  size?: number;
  className?: string;
}
const GeneralSurgeryIcon = t0 => {
  const $ = _c(10);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t10;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M17.1058 13.6583L12.9311 17.833L9.56738 15.4592L21.5638 3.46283C22.1815 2.84515 23.1829 2.84515 23.8006 3.46283C24.4182 4.08046 24.6854 6.07874 24.0678 6.69637L17.1058 13.6583Z" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M10.0671 16.0002L2.56714 23.5004C4.26973 24.2297 7.10709 23.9459 8.41683 22.6362L10.2595 20.7935L10.4297 19.7592L12.4997 17.6892" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t8 = <path d="M20.9671 8.84609C21.3261 8.84609 21.6171 9.13711 21.6171 9.49609C21.6171 9.85508 21.3261 10.1461 20.9671 10.1461V9.49609V8.84609ZM20.9671 9.49609V10.1461H15.5671V9.49609V8.84609H20.9671V9.49609Z" fill="currentColor" />;
    t9 = <path d="M23.4671 6.35C23.8261 6.35 24.1171 6.64101 24.1171 7C24.1171 7.35899 23.8261 7.65 23.4671 7.65V7V6.35ZM23.4671 7V7.65H18.0671V7V6.35H23.4671V7Z" fill="currentColor" />;
    t10 = <path d="M4.56738 24L20.5674 24" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t10;
    $[3] = t6;
    $[4] = t7;
    $[5] = t8;
    $[6] = t9;
  } else {
    t10 = $[2];
    t6 = $[3];
    t7 = $[4];
    t8 = $[5];
    t9 = $[6];
  }
  let t11;
  if ($[7] !== t3 || $[8] !== t5) {
    t11 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}{t8}{t9}{t10}</svg>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  return t11;
};
export default GeneralSurgeryIcon;